import React, { Fragment } from 'react';
import { showNotification } from './../../../utils';
import numeral from 'numeral';

const Order = React.memo((props) => {
    const handlePlaceOrder = () => {
        if (props.shipName === ''
            || props.shipAddress1 === ''
            || props.shipCity === ''
            || props.shipState === ''
            || props.shipZip === ''
            || props.shipPhone === ''
            || props.shipEmail === ''
            
        ) {
            showNotification('Complete Information', 'Complete all the required fields to continue', 'info');
            return;
        }

        if (props.user && props.user.username !== 'utp.manager' && (
            props.billName === ''
            || props.billAddress1 === ''
            || props.billCity === ''
            || props.billState === ''
            || props.billZip === ''
            || props.billPhone === ''
            || props.billEmail === ''
        )) {
            showNotification('Complete Information', 'Complete all the required fields to continue', 'info');
            return;
        }

        if (props.user && [5, 6].includes(parseInt(props.user.uth_type))) {
            if (props.cardNumber === ''
                || props.nameOnCard === ''
                || props.expirationMonth === ''
                || props.expirationYear === ''
                || props.securityNumber === ''
            ) {
                showNotification('Complete Information', 'Enter your credit card information', 'info');
                return;
            }
        }

        if (!props.shipEmail.trim().match(/^([a-zA-Z0-9_\-.]+)@([a-zA-Z0-9_\-.]+).([a-zA-Z]{2,5})$/)) {
            showNotification('Invalid Email address', 'The value entered in the ship email is not a valid email address', 'info');
            return;
        }

        if (props.user && props.user.username !== 'utp.manager' && !props.billEmail.trim().match(/^([a-zA-Z0-9_\-.]+)@([a-zA-Z0-9_\-.]+).([a-zA-Z]{2,5})$/)) {
            showNotification('Invalid Email address', 'The value entered in the bill email is not a valid email address', 'info');
            return;
        }

        props.placeOrder();
    };

    const sameAddressHandler = (event) => {
        props.setSameAddress(event.target.checked ? 1 : 0);
        if (event.target.checked) {
            props.setBillName(props.shipName);
            props.setBillAddress1(props.shipAddress1);
            props.setBillAddress2(props.shipAddress2);
            props.setBillCity(props.shipCity);
            props.setBillState(props.shipState);
            props.setBillZip(props.shipZip);
            props.setBillPhone(props.shipPhone);
            props.setBillEmail(props.shipEmail);
        }
    };

    const setShipNameHandler = (event) => {
        props.setShipName(event.target.value);
        if (props.sameAddress) {
            props.setBillName(event.target.value);
        }
    };

    const setShipAddress1Handler = (event) => {
        props.setShipAddress1(event.target.value);
        if (props.sameAddress) {
            props.setBillAddress1(event.target.value);
        }
    };

    const setShipAddress2Handler = (event) => {
        props.setShipAddress2(event.target.value);
        if (props.sameAddress) {
            props.setBillAddress2(event.target.value);
        }
    };

    const setShipCityHandler = (event) => {
        props.setShipCity(event.target.value);
        if (props.sameAddress) {
            props.setBillCity(event.target.value);
        }
    };

    const setShipStateHandler = (event) => {
        props.setShipState(event.target.value);
        if (props.sameAddress) {
            props.setBillState(event.target.value);
        }
    };

    const setShipZipHandler = (event) => {
        props.setShipZip(event.target.value);
        if (props.sameAddress) {
            props.setBillZip(event.target.value);
        }
    };

    const setShipPhoneHandler = (event) => {
        let phone = event.target.value;
        phone = phone.replace(/[A-Za-z_]/g, '');
        phone = phone.replace(/[.]/g, '');

        if (phone.length > 6) {
            phone = [phone.slice(0, 3), '.', phone.slice(3)].join('');
            phone = [phone.slice(0, 7), '.', phone.slice(7)].join('');
        } else if (phone.length > 3) {
            phone = [phone.slice(0, 3), '.', phone.slice(3)].join('');
        }

        props.setShipPhone(phone);
        if (props.sameAddress) {
            props.setBillPhone(phone);
        }
    };

    const setBillPhoneHandler = (event) => {
        let phone = event.target.value;
        phone = phone.replace(/[A-Za-z_]/g, '');
        phone = phone.replace(/[.]/g, '');

        if (phone.length > 6) {
            phone = [phone.slice(0, 3), '.', phone.slice(3)].join('');
            phone = [phone.slice(0, 7), '.', phone.slice(7)].join('');
        } else if (phone.length > 3) {
            phone = [phone.slice(0, 3), '.', phone.slice(3)].join('');
        }

        props.setBillPhone(phone);
    };

    const setShipEmailHandler = (event) => {
        props.setShipEmail(event.target.value);
        if (props.sameAddress) {
            props.setBillEmail(event.target.value);
        }
    };

    let buttonLabel = 'Order';
    if (props.cxmlData.buyer_cookie != null) {
        buttonLabel = 'Checkout'
    }
    if (props.ordering) {
        buttonLabel = <Fragment><i className="fas fa-circle-notch fa-spin" /> Creating Order...</Fragment>;
    }

    const handleSubmitForm = () => {
        props.placeOrder(2);
    };

    let monthOptions = [];
    for (let i = 1; i <= 12; i++) {
        monthOptions.push(<option key={'month-' + i} value={numeral(i).format('00')}>{numeral(i).format('00')}</option>)
    }

    let yearOptions = [];
    for (let i = 22; i <= 40; i++) {
        yearOptions.push(<option key={'month-' + i} value={i}>20{i}</option>)
    }

    const setCreditCardFieldHandler = (setFunction, event) => {
        setFunction(event.target.value);
    };

    let creditCardFields = null;
    if (props.user && [5, 6].includes(parseInt(props.user.uth_type))) {
        creditCardFields = (
            <Fragment>
                <hr />
                <h6 className="mt-3 mb-3">Credit Card Information</h6>
                <div className="field">
                    <div className="title">Card Number <span className="required">*</span>:</div>
                    <input type="text" value={props.cardNumber} onChange={setCreditCardFieldHandler.bind(this, props.setCardNumber)} />
                </div>
                <div className="field">
                    <div className="title">Name on Card <span className="required">*</span>:</div>
                    <input type="text" value={props.nameOnCard} onChange={setCreditCardFieldHandler.bind(this, props.setNameOnCard)} />
                </div>
                <div className="field">
                    <div className="title">Expiration <span className="required">*</span>:</div>
                    <div className="expiration-fields">
                        <select className="expiration-month" value={props.expirationMonth} onChange={setCreditCardFieldHandler.bind(this, props.setExpirationMonth)}>
                            <option value="">Select Month</option>
                            {monthOptions}
                        </select>
                        /
                        <select className="expiration-year" value={props.expirationYear} onChange={setCreditCardFieldHandler.bind(this, props.setExpirationYear)}>
                            <option value="">Select Year</option>
                            {yearOptions}
                        </select>
                    </div>
                </div>
                <div className="field">
                    <div className="title">Security Number <span className="required">*</span>:</div>
                    <input type="text" value={props.securityNumber} onChange={setCreditCardFieldHandler.bind(this, props.setSecurityNumber)} />
                </div>
            </Fragment>
        );
    }

    let billToSection = (
        <div className="bill-to">
            <h6>
                <div>Bill To</div>
                <div className="same-address"><input type="checkbox" checked={props.sameAddress} onClick={sameAddressHandler} /> Sames as ship to</div>
            </h6>
            <hr />
            <div className="field">
                <div className="title">Name <span className="required">*</span>:</div>
                <input type="text" value={props.billName} onChange={(event) => props.setBillName(event.target.value)} />
            </div>
            <div className="field">
                <div className="title">Address 1 <span className="required">*</span>:</div>
                <input type="text" value={props.billAddress1} onChange={(event) => props.setBillAddress1(event.target.value)} />
            </div>
            <div className="field">
                <div className="title">Address 2:</div>
                <input type="text" value={props.billAddress2} onChange={(event) => props.setBillAddress2(event.target.value)} />
            </div>
            <div className="field">
                <div className="title">City <span className="required">*</span>:</div>
                <input type="text" value={props.billCity} onChange={(event) => props.setBillCity(event.target.value)} />
            </div>
            <div className="field">
                <div className="title">State <span className="required">*</span>:</div>
                <input type="text" value={props.billState} onChange={(event) => props.setBillState(event.target.value)} />
            </div>
            <div className="field">
                <div className="title">Zip <span className="required">*</span>:</div>
                <input type="text" value={props.billZip} onChange={(event) => props.setBillZip(event.target.value)} />
            </div>
            <hr />
            <div className="field">
                <div className="title">Phone <span className="required">*</span>:</div>
                <input type="text" value={props.billPhone} onChange={setBillPhoneHandler} />
            </div>
            <div className="field">
                <div className="title">Email <span className="required">*</span>:</div>
                <input type="text" value={props.billEmail} onChange={(event) => props.setBillEmail(event.target.value)} />
            </div>
            <hr />
            <h6>Additional Info (Optional)</h6>
            <div className="field">
                <div className="title">PO #:</div>
                <input type="text" value={props.billPo} onChange={(event) => props.setBillPo(event.target.value)} />
            </div>
            <div className="field">
                <div className="title">Dept. Info:</div>
                <input type="text" value={props.billDepartment} onChange={(event) => props.setBillDepartment(event.target.value)} />
            </div>
            <div className="call-field">
                <input type="checkbox" checked={props.billCall} onChange={(event) => props.setBillCall(event.target.checked ? 1 : 0)} /> Please call for CC#
                    </div>
            <div className="field">
                <div className="title">Notes:</div>
                <textarea value={props.billNotes} onChange={(event) => props.setBillNotes(event.target.value)} />
            </div>
        </div>
    );
    let addressContainerClass = '';
    let shipBorderClass = ' ship-border';
    if (props.user && props.user.username === 'utp.manager') {
        billToSection = null;
        addressContainerClass = ' address-container-only-ship';
        shipBorderClass = '';
    }

    let formContainer = (
        <div className={'addresses-container' + addressContainerClass}>
            <div className={'ship-to' + shipBorderClass}>
                <h6>Ship To</h6>
                <hr />
                <div className="field">
                    <div className="title">Name <span className="required">*</span>:</div>
                    <input type="text" value={props.shipName} onChange={setShipNameHandler} />
                </div>
                <div className="field">
                    <div className="title">Address 1 <span className="required">*</span>:</div>
                    <input type="text" value={props.shipAddress1} onChange={setShipAddress1Handler} />
                </div>
                <div className="field">
                    <div className="title">Address 2:</div>
                    <input type="text" value={props.shipAddress2} onChange={setShipAddress2Handler} />
                </div>
                <div className="field">
                    <div className="title">City <span className="required">*</span>:</div>
                    <input type="text" value={props.shipCity} onChange={setShipCityHandler} />
                </div>
                <div className="field">
                    <div className="title">State <span className="required">*</span>:</div>
                    <input type="text" value={props.shipState} onChange={setShipStateHandler} />
                </div>
                <div className="field">
                    <div className="title">Zip <span className="required">*</span>:</div>
                    <input type="text" value={props.shipZip} onChange={setShipZipHandler} />
                </div>
                <hr />
                <div className="field">
                    <div className="title">Phone <span className="required">*</span>:</div>
                    <input type="text" value={props.shipPhone} onChange={setShipPhoneHandler} />
                </div>
                <div className="field">
                    <div className="title">Email <span className="required">*</span>:</div>
                    <input type="text" value={props.shipEmail} onChange={setShipEmailHandler} />
                </div>
                <hr />
                <div className="field">
                    <div className="title">Notes:</div>
                    <textarea value={props.shipNotes} onChange={(event) => props.setShipNotes(event.target.value)} />
                </div>
                {creditCardFields}
            </div>
            {billToSection}
        </div>
    );
    let formContent = (
        <div className="text-center">
            <button type="button" onClick={handlePlaceOrder} disabled={props.ordering}>{buttonLabel}</button>
        </div>
    );
    if (props.cxmlData.buyer_cookie != null) {
        formContent = (
            <form id="cxml-form" action={props.cxmlData.browser_form_post} method="post" className="text-center">
                <input type="hidden" id="cxml-urlencoded" name="cxml-urlencoded" value="" />
                <button type="button" onClick={handleSubmitForm} disabled={props.ordering}>{buttonLabel}</button>
            </form>
        );
        formContainer = null;
    }

    return (
        <div className="form-container">
            {formContainer}
            {formContent}
        </div>
    );
});

Order.propTypes = {

}

export default Order;
